import {COLORS, Z_INDEXES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {
  SEARCH_BAR_ANIMATION_TIME_MS,
  SEARCH_BAR_OVERLAY_TOP_CSS_VAR,
} from '../constants';

export const SearchBarPageOverlay: FC<{
  onDismiss: VoidFunction;
}> = ({onDismiss}) => (
  <>
    <PageOverlay onClick={onDismiss} data-testid="searchBarPageOverlay" />
    <NavigationFadeMask onClick={onDismiss} />
  </>
);

const PageOverlay = styled.div`
  position: fixed;
  top: var(${SEARCH_BAR_OVERLAY_TOP_CSS_VAR}, 0px);
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${Z_INDEXES.TADARIDA_HEADER_SEARCH_OVERLAY};
  background-color: rgba(0, 0, 0, 0.4);
  animation: fadeInOverlay ${SEARCH_BAR_ANIMATION_TIME_MS}ms ease-in;

  @keyframes fadeInOverlay {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`;

const NavigationFadeMask = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) 14%,
    ${COLORS.White} 31%,
    ${COLORS.White} 100%
  );
  animation: fadeInOverlay ${SEARCH_BAR_ANIMATION_TIME_MS}ms ease-in;

  @keyframes fadeInOverlay {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`;
